





























































































import mixins from 'vue-typed-mixins'
import {
  LocationType,
  Location,
  LocationAddress,
} from '@/interfaces/valuation/types/LocalityValuationStep'
import localityPicker, {
  AutocompleteObject,
  AutocompleteObjectStreet,
} from '@/mixins/valuation/localityPicker'
import { AddressCMService } from '@/services/location/addressCM'
import { IdValueObject, ValidatedResponse } from '@/interfaces/app/ValueObjects'
import { getNestedValue } from '@/util/helpers'

export default mixins(localityPicker).extend({
  name: `${LocationType.Address}-picker`,
  created() {
    if (this.locationData) {
      this.cachedLocationData = JSON.parse(JSON.stringify(this.locationData))
    }
    this.region.loading = true
    this.addressLocationService
      .getRegions()
      .then(regions => {
        this.region.items = regions as IdValueObject[]
        const cachedId = getNestedValue(this.cachedLocationData, [
          'locationAddressRegionId',
        ])
        if (cachedId && this.region.items.find(i => i.id === cachedId)) {
          this.region.id = cachedId
        }
      })
      .finally(() => (this.region.loading = false))
  },
  data(): {
    region: AutocompleteObject
    district: AutocompleteObject
    municipality: AutocompleteObject
    street: AutocompleteObjectStreet
    houseNumber: AutocompleteObject
    cachedLocationData: LocationAddress | undefined
  } {
    return {
      region: {
        id: undefined,
        search: '',
        items: [],
        loading: false,
      },
      district: {
        id: undefined,
        search: '',
        items: [],
        loading: false,
      },
      municipality: {
        id: undefined,
        search: '',
        items: [],
        loading: false,
      },
      street: {
        id: '',
        search: '',
        items: [],
        loading: false,
      },
      houseNumber: {
        id: undefined,
        search: '',
        items: [],
        loading: false,
      },
      cachedLocationData: undefined,
    }
  },
  computed: {
    locationData(): LocationAddress | undefined {
      const stepData = this.$store.getters['valuationProcess/currentStepData']
      if (stepData.location) {
        return stepData.location as LocationAddress
      }
    },
    addressLocationService(): AddressCMService {
      return this.locationService as AddressCMService
    },
    location(): ValidatedResponse<LocationAddress> {
      if (
        !this.region.id ||
        !this.region.search ||
        !this.district.id ||
        !this.district.search ||
        !this.municipality.id ||
        !this.municipality.search ||
        !this.street.id ||
        !this.houseNumber.id ||
        !this.houseNumber.search
      ) {
        return { valid: false }
      }

      return {
        valid: true,
        value: {
          locationAddressRegion: this.region.search,
          locationAddressRegionId: this.region.id,
          locationAddressDistrict: this.district.search,
          locationAddressDistrictId: this.district.id,
          locationAddress: this.houseNumber.search,
          locationAddressId: this.houseNumber.id,
          locationAddressStreet: this.street.id,
          locationMunicipality: this.municipality.search,
          locationMunicipalityId: this.municipality.id,
        },
      }
    },
  },
  methods: {
    resetDistrict() {
      this.district.id = undefined
      this.district.search = ''
    },
    resetMunicipality() {
      this.municipality.id = undefined
      this.municipality.search = ''
    },
    resetStreet() {
      this.street.id = ''
      this.street.search = ''
    },
    resetHouseNumber() {
      this.houseNumber.id = undefined
      this.houseNumber.search = ''
    },
  },
  watch: {
    'region.id'(value: number | undefined) {
      this.resetHouseNumber()
      this.resetStreet()
      this.resetMunicipality()
      this.resetDistrict()

      if (!value) {
        return
      }
      this.district.loading = true
      this.addressLocationService
        .getDistricts(value)
        .then(districts => {
          this.district.items = districts as IdValueObject[]
          const cachedId = getNestedValue(this.cachedLocationData, [
            'locationAddressDistrictId',
          ])
          if (cachedId && this.district.items.find(i => i.id === cachedId)) {
            this.district.id = cachedId
          }
        })
        .finally(() => (this.district.loading = false))
    },
    'district.id'(value: number | undefined) {
      this.resetHouseNumber()
      this.resetStreet()
      this.resetMunicipality()
      if (!value) {
        return
      }
      this.municipality.loading = true
      this.addressLocationService
        .getMunicipalities(value)
        .then(municipalities => {
          this.municipality.items = municipalities as IdValueObject[]
          const cachedId = getNestedValue(this.cachedLocationData, [
            'locationMunicipalityId',
          ])
          if (
            cachedId &&
            this.municipality.items.find(i => i.id === cachedId)
          ) {
            this.municipality.id = cachedId
          }
        })
        .finally(() => (this.municipality.loading = false))
    },
    'municipality.id'(value: number | undefined) {
      this.resetHouseNumber()
      this.resetStreet()

      if (!value) {
        return
      }
      this.street.loading = true
      this.addressLocationService
        .getStreets(value)
        .then(streets => {
          this.street.items = streets as string[]
          const cachedStreet = getNestedValue(this.cachedLocationData, [
            'locationAddressStreet',
          ])
          if (cachedStreet && this.street.items.find(i => i === cachedStreet)) {
            this.street.id = cachedStreet
          }
        })
        .finally(() => (this.street.loading = false))
    },
    'street.id'(value: string) {
      this.resetHouseNumber()
      if (!value) {
        return
      }
      this.houseNumber.loading = true
      this.addressLocationService
        .getHouseNumbers(this.municipality.id!, value)
        .then(houseNumbers => {
          this.houseNumber.items = houseNumbers as IdValueObject[]
          const cachedId = getNestedValue(this.cachedLocationData, [
            'locationAddressId',
          ])
          if (cachedId && this.houseNumber.items.find(i => i.id === cachedId)) {
            this.houseNumber.id = cachedId
          }
        })
        .finally(() => (this.houseNumber.loading = false))
    },
  },
})
